var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"items",class:{orderlist: _vm.orderlist}},_vm._l((_vm.products),function(item){return _c('item',_vm._b({key:item.id},'item',[item, {orderlist: _vm.orderlist}],false))}))}
var staticRenderFns = []

export { render, staticRenderFns }